//fullName from firstName and LastName
export const getFullNameString = (firstName?: string, lastName?: string) => {
    let spaceCondition = firstName && lastName ? " " : ""
    return `${firstName || ""}${spaceCondition}${lastName || ""}`
}
//Shortcut start letter from firstName and lastName
export const getShortcutFromFullNameString = (firstName?: string, lastName?: string) => {
    const result =
        !firstName && !lastName
            ? ""
            : `${firstName?.charAt(0)?.toUpperCase()}${lastName?.charAt(0)?.toUpperCase()}`
    return result
}

export const getFirstLetterUpper = (string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1)
}

const hex = (value: number) => Math.floor(value).toString(16)

export const generateObjectId = () => {
    return hex(Date.now() / 1000) + " ".repeat(16).replace(/./g, () => hex(Math.random() * 16))
}

export const splitIntoSentences = (text: string): string[] => {
    return text
        .split(/\. (?=[A-Z])/g)
        .map((s) => s.trim())
        .filter(Boolean)
        .map((s) => (s.endsWith(".") ? s : s + "."))
}
